import "./es.object.assign-7e79fd7b.js";
import { useState as A, useRef as O, useEffect as d } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { _ as j } from "./getTarget-19e0f923.js";
import { useEventListener as E } from "./useEventListener.js";
import { overflownDefaults as X, useOverFlown as Y } from "./useOverFlown.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./isClient-2f5bedbd.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
var v = Object.assign({
  isScrollable: !1,
  isScrollableX: !1,
  isScrollableY: !1,
  isScrollAtStart: !0,
  isScrollXAtStart: !0,
  isScrollYAtStart: !0,
  isScrollAtEnd: !1,
  isScrollXAtEnd: !1,
  isScrollYAtEnd: !1
}, X), T = function(e) {
  var t = j(e.target);
  if (!t)
    return v;
  var c = t.scrollLeft, r = t.scrollTop, a = t.scrollWidth, l = t.scrollHeight, i = t.clientWidth, s = t.clientHeight, n = e.isOverFlownX, p = e.isOverFlownY, h = n || p, u = n && Math.ceil(c + i) >= Math.ceil(a), S = p && Math.ceil(r + s) >= Math.ceil(l), f = n && c === 0, g = p && r === 0;
  return {
    isScrollable: h,
    isScrollableX: n,
    isScrollableY: p,
    isScrollAtEnd: u || S,
    isScrollAtStart: f || g,
    isScrollXAtEnd: u,
    isScrollYAtEnd: S,
    isScrollXAtStart: f,
    isScrollYAtStart: g,
    scrollLeft: c,
    scrollTop: r,
    scrollWidth: a,
    scrollHeight: l,
    clientWidth: i,
    clientHeight: s,
    scrollTo: function(o) {
      return t.scrollTo(o);
    },
    scrollToTop: function(o) {
      return t.scrollTo(Object.assign({}, o, {
        top: 0
      }));
    },
    scrollToBottom: function(o) {
      return t.scrollTo(Object.assign({}, o, {
        top: l
      }));
    },
    scrollToLeft: function(o) {
      return t.scrollTo(Object.assign({}, o, {
        left: 0
      }));
    },
    scrollToRight: function(o) {
      return t.scrollTo(Object.assign({}, o, {
        left: a
      }));
    }
  };
}, ct = function(e, t) {
  var c = A(v), r = c[0], a = c[1], l = O(t);
  return d(function() {
    l.current = t;
  }, [t]), Y(e, function(i) {
    var s = Object.assign({}, r, i, T(Object.assign({}, r, i)));
    a(s), l.current == null || l.current(s);
  }), E("scroll", function(i) {
    var s = Object.assign({}, r, {
      target: i.target
    }, T(Object.assign({}, r, {
      target: i.target
    })));
    a(s), l.current == null || l.current(s);
  }, e), r;
};
export {
  ct as useScroll
};
